import React, { useEffect, useState } from "react";
import Orders from "./Orders";
import StatusChangeModal from "../FunctionalComponents/StatusChangeModal";

const ClientOrders = () => {
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("Received");
  const [activeTab, setActiveTab] = useState("Received Orders");
  const [expandedCard, setExpandedCard] = useState(null); // Track expanded card ID

  const handleChangeStatus = (newStatus) => {
    console.log("Status changed to:", newStatus);
    setShowStatusModal(false); // Close the modal after saving
  };

  return (
    <div>
      {/* Orders Section */}
      <Orders
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setShowStatusModal={setShowStatusModal}
        setExpandedCard={setExpandedCard}
        expandedCard={expandedCard}
        showNavigateBack={true}
      />

      {
        showStatusModal && (
          <StatusChangeModal
            showStatusModal={showStatusModal}
            setShowStatusModal={setShowStatusModal}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            handleChangeStatus={handleChangeStatus}
          />
        )
      }
    </div>
  )
}
export default ClientOrders;